// Meta Pixel (Facebook) – loads only after explicit marketing consent.
export const META_PIXEL_ID = '1067260249198117';

declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
    __aimupPixelLoaded?: boolean;
  }
}

export const loadMetaPixel = () => {
  if (typeof window === 'undefined') return;
  try {
    if (window.__aimupPixelLoaded) {
      window.fbq?.('consent', 'grant');
      return;
    }
    window.__aimupPixelLoaded = true;

    /* eslint-disable */
    (function (f: any, b: Document, e: string, v: string, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    window.fbq?.('consent', 'grant');
    window.fbq?.('init', META_PIXEL_ID);
  } catch {
    /* ignore */
  }
};

export const disableMetaPixel = () => {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('consent', 'revoke');
    }
  } catch {
    /* ignore */
  }
};

export const trackPixelPageView = () => {
  try {
    if (typeof window === 'undefined') return;
    if (window.__aimupPixelLoaded && window.fbq) {
      window.fbq('track', 'PageView');
    }
  } catch {
    /* ignore */
  }
};

export const trackPixelCompleteRegistration = () => {
  if (typeof window === 'undefined' || !window.__aimupPixelLoaded || !window.fbq) return;
  try {
    window.fbq('track', 'CompleteRegistration');
  } catch {
    /* noop */
  }
};
